import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';

//変数の設定
var $body = $('body');

//スクロール量を保存
var scrollTop;

//スクロールを固定
function bodyFixedOn() {
  scrollTop = $(window).scrollTop();
  
  $body.css({
    position: 'fixed',
    top: -scrollTop
  });
}

//スクロールの固定を解除
function bodyFixedOff() {
  $body.css({
    position: '',
    top: ''
  });
  
  $(window).scrollTop(scrollTop);
}

//モーダルのトリガーをクリックしたとき
/*$('.popup-modal').on('click', function() {
  bodyFixedOn();
});

//モーダルの閉じるボタンをクリックしたとき
$('.popup-modal-dismiss').on('click', function() {
  bodyFixedOff();
});

//モーダルのオーバーレイをクリックしたとき
$('.mfp-bg').on('click', function() {
  bodyFixedOff();
});*/

$(function () {
    $('.popup-modal').magnificPopup({
      type: 'inline',
      preloader: false
    });
    //閉じるリンクの設定
    $(document).on('click', '.popup-modal-dismiss', function (e) { 
      e.preventDefault();
      $.magnificPopup.close();
    });
  });